const LANGUAGES = [
    {
        "id": "de",
        "name": "Deutsch",
        "code": "de_DE"
    },
    {
        "id": "es",
        "name": "Español",
        "code": "es_ES"
    },
    {
        "id": "fr",
        "name": "Français",
        "code": "fr_FR"
    },
    {
        "id": "en",
        "name": "English",
        "code": "en_EN"
    },
    {
        "id": "it",
        "name": "Italiano",
        "code": "it_IT"
    },
    {
        "id": "nl",
        "name": "Dutch",
        "code": "nl_NL"
    },
    {
        "id": "pl",
        "name": "Polski",
        "code": "pl_PL"
    },
    {
        "id": "pt",
        "name": "Portugués",
        "code": "pt_PT"
    },
    {
        "id": "ro",
        "name": "Română",
        "code": "ro_RO"
    },
    {
        "id": "be",
        "name": "Belgique / België",
        "code": "be_BE"
    }
];

export default LANGUAGES;
